import { createContext } from 'react'

const defaultState = {
  userId: undefined,
  resident: undefined,
  user: undefined,
  accessToken: undefined,
}

export const ImperialBookingContext = createContext(defaultState)
